import { render, staticRenderFns } from "./InvitedDoctors.vue?vue&type=template&id=6467cb3a&scoped=true"
import script from "./InvitedDoctors.vue?vue&type=script&lang=js"
export * from "./InvitedDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467cb3a",
  null
  
)

export default component.exports